import React from "react";

import { observer } from "mobx-react-lite";
import { ViewDocument } from "../../../components/templates/ViewDocument";
import { TypeContractEnum } from "../../../enum/contract";
import { env } from "../../../config";

export const TermsOfConditions: React.FC = observer(() => (
	<ViewDocument url={env.blob.termsOfConditions} type={TypeContractEnum.ACCOUNT_CREATION} />
));
